var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#F0F3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2045 8.97543H17.3278V7.37874C17.3278 6.61848 16.7227 6 15.9789 6H12.0208C11.277 6 10.6719 6.61848 10.6719 7.37874V8.97543H6.7952C5.80763 8.97543 5.00416 9.79668 5.00416 10.8061C5.00416 11.723 4.91229 12.5464 5.59208 13.4724C5.97669 13.9964 6.50524 14.3701 7.12054 14.5532L13.0956 16.3314C13.6871 16.5074 14.3125 16.5074 14.9041 16.3314L20.8791 14.5532C21.4944 14.3701 22.023 13.9964 22.4076 13.4724C23.0904 12.5423 22.9955 11.7104 22.9955 10.8061C22.9955 9.79668 22.1921 8.97543 21.2045 8.97543ZM11.8145 7.37874C11.8145 7.26243 11.9071 7.16784 12.0208 7.16784H15.9789C16.0927 7.16784 16.1853 7.26247 16.1853 7.37874V8.97543H11.8145V7.37874Z",
    fill: "#717D9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1986 15.6745C14.7538 17.5924 14.8372 17.6312 13.9999 17.6312C13.1685 17.6312 13.3657 17.6281 6.80119 15.6745C6.10905 15.4685 5.49607 15.0888 5.00419 14.5654V20.1694C5.00419 21.1788 5.80763 22 6.79523 22H21.2045C22.1921 22 22.9956 21.1788 22.9956 20.1694V14.5654C22.5037 15.0888 21.8907 15.4685 21.1986 15.6745Z",
    fill: "#717D9A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.88ec5b9605dd7e3a25447851d5e8488d.svg";
export { ForwardRef as ReactComponent };